import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { BIGQUERY } from "../../Constants"

function ZdqBigQueryConnector() {
    return <ZdqConnectorSetup vendor={BIGQUERY}></ZdqConnectorSetup>
}

export default ZdqBigQueryConnector 